'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002emutable$002e$002dSet from "./scala.collection.mutable.-Set.js";
var $p;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2(outer) {
  this.At = null;
  this.wF = null;
  this.MX = null;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  this.MX = outer;
  this.At = outer.qr.s();
  this.wF = $j_java$002elang$002e$002dObject.$m_s_None$();
}
export { $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2 as $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2 };
$p = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2() {
}
export { $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2 as $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2 };
$h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2.prototype = $p;
$p.i = (function() {
  return this.At.i();
});
$p.e = (function() {
  var e = this.At.e();
  this.wF = new $j_java$002elang$002e$002dObject.$c_s_Some(e);
  return e;
});
$p.rg = (function() {
  var x15 = this.wF;
  if ((x15 instanceof $j_java$002elang$002e$002dObject.$c_s_Some)) {
    var e = x15.Q;
    var x13 = this.MX.qr;
    if ($j_scala$002ecollection$002emutable$002e$002dSet.$is_scm_Set(x13)) {
      x13.la(e);
      this.wF = $j_java$002elang$002e$002dObject.$m_s_None$();
      return (void 0);
    }
    throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__T__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException(), "remove");
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalStateException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalStateException(), "next must be called at least once before remove");
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2, "scala.collection.convert.JavaCollectionWrappers$SetWrapper$$anon$2", ({
  sT: 1,
  bd: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2 as $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2 };
